
import { postPayment } from "@/api/payout";
import { ICreatePayment } from "@/api/types/payout";
import SvgMagicWand from '@/assets/icons/magic-wand-light.svg';
import CreatePaymentHeader from "@/components/affiliate/payments/createPayment/CreatePaymentHeader.vue";
import CreatePaymentNearestTable from "@/components/affiliate/payments/createPayment/CreatePaymentNearestTable.vue";
import CreatePaymentsBody from "@/components/affiliate/payments/createPayment/CreatePaymentsBody.vue";
import PageLayout from "@/components_v3/layout/PageLayout.vue";
import { showServerError } from "@/utils";
import { NotificationMessage } from "@/utils/notification";
import { Component, Ref, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { namespace } from "vuex-class";
import { getCurrentDate } from "../../../utils/formatDates";

const auth = namespace('authModule');

@Component({
    beforeRouteEnter(to: Route, from: Route, next: (arg0?: (vm: CreatePayment) => void) => void) {
        next(vm => {
            const headerRef = vm.$refs.header as CreatePaymentHeader;
            if (headerRef && from.params?.id) {
                headerRef.defaultAffiliateValue = from.params.id;
            }
        });
    },
    components: { CreatePaymentsBody, CreatePaymentNearestTable, CreatePaymentHeader, PageLayout, SvgMagicWand },
})

export default class CreatePayment extends Vue {
    @Ref() header!: CreatePaymentHeader;
    @Ref() paymentBody!: CreatePaymentsBody;
    @auth.Getter('GET_USER') user!: { account_id: number };

    loadingBtn: boolean = false;
    payment: ICreatePayment = {
        period: '',
        comment: '',
        exchange_rates: {
            currency: '',
            rate: 0,
            date: getCurrentDate('yyyy-MM-dd'),
        },
    };
    isBodyValid: boolean = false;

    get isShowBodyPayment(): boolean {
        return !!(this.payment.payment_type && this.payment.affiliate_id);
    }

    get isCanSave(): boolean {
        return this.isBodyValid && !this.isExcesSum;
    }

    get isExcesSum(): boolean {
        if (this.payment.payment_type !== 'invoice_payment') {
            return false;
        }
        const { paid_sum, available_sum } = this.payment;
        return paid_sum !== undefined && available_sum !== undefined && paid_sum > available_sum;
    }

    private createInitialPayment(affiliateId?: number): ICreatePayment {
        return {
            period: '',
            comment: '',
            affiliate_id: affiliateId,
            exchange_rates: {
                currency: '',
                rate: 0,
                date: getCurrentDate('yyyy-MM-dd'),
            },
        } as ICreatePayment;
    }

    async savePayment(): Promise<void> {
        this.loadingBtn = true;
        try {
            this.$set(this.payment, 'manager_id', this.user.account_id);
            if (!this.payment.commission) {
                this.payment.commission = 0;
            }
            const { currency, exchange_rates: { currency: exchangeCurrency } } = this.payment;
            if (currency === exchangeCurrency) {
                this.payment.exchange_rates.currency = null;
                this.payment.exchange_rates.rate = null;
            }
            this.payment.final_currency = exchangeCurrency ?? currency;

            await postPayment(this.payment);
            new NotificationMessage('Досрочка создана', 'success');

            const affiliateId = this.payment.affiliate_id;
            this.payment = this.createInitialPayment(affiliateId);
            this.header.clearPaymentType();
        } catch (err) {
            showServerError(err, 'Досрочка не создана');
        } finally {
            this.loadingBtn = false;
        }
    }
}
